<template>
  <div class="footer-main">
    <div class="footer-main-logo">
      <component
        :is="currentPath === siteDir ? 'span' : 'a'"
        :href="currentPath === siteDir ? null : siteDir"
        class="footer-main-logo__link"
      >
        <svg><use xlink:href="#svg-logo-high"></use></svg>
      </component>
    </div>
    <div class="footer-main__catalog">
      <FooterMenu :result="catalog" />
      <FooterCountries v-if="screenWidth >= 992" />
    </div>
    <div class="footer-main__customer">
      <FooterMenu :result="customer" />
    </div>
    <div class="footer-main__menus"></div>
    <div class="footer-main__about">
      <FooterMenu :result="company" />
    </div>
    <div class="footer-main__information">
      <FooterInformation />
    </div>
    <FooterCountries v-if="screenWidth < 992" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FooterMenu from '@components/Footer/FooterMenu.vue';
import FooterInformation from '@components/Footer/FooterInformation.vue';
import FooterCountries from '@components/Footer/FooterCountries.vue';
import useScreenWidth from '@use/useScreenWidth';

export default {
  name: 'FooterMain',
  components: { FooterCountries, FooterInformation, FooterMenu },
  data() {
    return {
      currentPath: location.pathname,
      screenWidth: useScreenWidth(),
    };
  },
  // methods: { useScreenWidth },
  computed: {
    ...mapState({
      catalog: ({ results }) => results.menus.catalog,
      company: ({ results }) => results.menus.company,
      customer: ({ results }) => results.menus.customer,
      siteDir: ({ results }) => results?.siteLanguages?.siteDir,
    }),
  },
};
</script>

<style lang="scss" scoped>
.footer-main {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-column-gap: 20px;
  margin-bottom: 24px;
  grid-template-areas:
    'logo'
    'catalog'
    'customer'
    'about'
    'information';
  padding-top: 24px;
  @include point-lg {
    grid-template-columns: repeat(4, 1fr);
    grid-template-areas: 'logo catalog customer about information';
    padding-top: 64px;
    margin-bottom: 32px;
  }
  &__catalog {
    grid-area: catalog;
  }
  &__customer {
    grid-area: customer;
  }
  &__about {
    grid-area: about;
    margin-bottom: 24px;
    @include point-lg {
      margin-bottom: 0;
    }
  }
  &__information {
    grid-area: information;
  }
}
.footer-main-logo {
  grid-area: logo;
  margin-bottom: 24px;
  @include point-lg {
    margin-bottom: 0;
  }
  &__link {
    display: inline-block;
  }
  svg {
    width: 50px;
    height: 72px;
    fill: #fff;
    @include point-md {
      width: 70px;
      height: 100px;
    }
    @include point-lg {
      width: 105px;
      height: 150px;
    }
  }
}
</style>
